import PropTypes from 'prop-types';
import { useState } from 'react';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import { addCommas } from '../utils/numberUtils.ts';


export const Tabs = function (props) {
    const [showDropdown, setShowDropdown] = useState(false);

    function toggleDropdown(event) {
        event.preventDefault();
        const toggleState = !showDropdown;
        setShowDropdown(toggleState);
    }

    var validTabs = props.validTabs;
    var tabs = validTabs.entrySeq().map(o => <Tab {...props} tab={o[1]} key={o[0]} />);

    if (props.isMobile && props.isMobileDropdownStyle) {
        var currentTab = validTabs.get(props.activeTabName);
        var currentLabel = currentTab.get('label');
        var currentCount = currentTab.get('count') ? `(${addCommas(currentTab.get('count'))})` : '';

        if (showDropdown) {
            var subNav =
                <div className="subnav ignore-react-onclickoutside dropdown-options">
                    {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                    <ul role="listbox" onClick={toggleDropdown} onKeyDown={toggleDropdown}>
                        {tabs}
                    </ul>
                </div>;
        }

        return (
            <div className="sort-projects select-with-dropdown mobile">
                <span>show </span>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" onClick={toggleDropdown}>
                    <span>{currentLabel} {currentCount}</span>
                    <Svg icon="navigatedown" attributes={{ role: 'presentation' }}/>
                </a>
                {subNav}
            </div>
        );
    }

    return props.isMobile
        ? <div>{tabs}</div>
        : <ul className="DCtabs on-grey">{tabs}</ul>;
};

Tabs.defaultProps = {
    isMobileDropdownStyle: false,
};

Tabs.propTypes = {
    validTabs: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isMobileDropdownStyle: PropTypes.bool,

    activeTabName: PropTypes.string,
    content: PropTypes.node,
    activateTab: PropTypes.func,
    closeTab: PropTypes.func,
};

var Tab = function (props) {
    function changeTab(event) {
        event.preventDefault();

        if (!isActive()) {
            const newTab = props.tab.get('name');
            if (props.activateTab) {
                props.activateTab(newTab);
            } else {
                $(window).trigger('tabChanged', newTab);
            }
        } else if (props.isMobile && !props.isMobileDropdownStyle) {
            if (props.closeTab) {
                props.closeTab();
            } else {
                $(window).trigger('closeTab');
            }
        }
    }

    function isActive() {
        return props.activeTabName === props.tab.get('name');
    }

    var tab = props.tab;

    var divClass = 'accordion-trigger';
    if (isActive()) {
        divClass += ' active';
        var anchorClass = 'active';
        var content = props.content;
    }

    var tabName = props.tab.get('name').toLowerCase();

    if (tab.get('count')) {
        var tabCount = <span className="highlight-count">{addCommas(tab.get('count'))}</span>;
    }

    var tabLink = (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        (<a className={anchorClass} href="#" onClick={changeTab}>
            <span className="toggle-title">
                {tab.get('label')} {tabCount}
            </span>
        </a>)
    );

    if (props.isMobile && !props.isMobileDropdownStyle) {
        return (
            <div className={tabName}>
                <div className={divClass}>
                    {tabLink}
                </div>
                {content}
            </div>
        );
    } else {
        return (
            <li className={tabName}>
                {tabLink}
            </li>
        );
    }
};

Tab.propTypes = {
    tab: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    isMobileDropdownStyle: PropTypes.bool.isRequired,

    activeTabName: PropTypes.string,
    activateTab: PropTypes.func,
    closeTab: PropTypes.func,
    content: PropTypes.node,
};
